import React from 'react';
import { downloadDocument } from '../utils/documentDownload';
import './DocumentActionButtons.css';

const EyeIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.25 12s3.5-6 9.75-6 9.75 6 9.75 6-3.5 6-9.75 6S2.25 12 2.25 12Z" /><circle cx="12" cy="12" r="3" /></svg>
);

const DownloadIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v12m0 0 4-4m-4 4-4-4M4 19.5h16" /></svg>
);

export default function DocumentActionButtons({ url, previewUrl = url, fileName, allowPreview = true, onDownloadError }) {
  return (
    <footer className="document-card-actions">
      {allowPreview && (
        <a href={previewUrl} target="_blank" rel="noopener noreferrer" aria-label={`${fileName || 'कागदपत्र'} पहा`} title="पहा">
          <EyeIcon />
        </a>
      )}
      <button type="button" onClick={() => downloadDocument(url, fileName).catch(onDownloadError)} aria-label={`${fileName || 'कागदपत्र'} डाउनलोड करा`} title="डाउनलोड करा">
        <DownloadIcon />
      </button>
    </footer>
  );
}
